
import React from 'react';

interface TransactionDescriptionProps {
  description: string;
}

const TransactionDescription: React.FC<TransactionDescriptionProps> = ({ description }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-muted-foreground mb-1">Description</h3>
      <p>{description || 'No description provided'}</p>
    </div>
  );
};

export default TransactionDescription;
